import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import swal from 'sweetalert2';
import './addFlyleaf.css';
import {
  createPage,
  createPageReorder,
  setIsActive,
  setLayoutToActivePage } from './../../../../redux/actions/entities/pages';
import {
  isImageInChange,
  convertObjectToArray,
  showAlertModal,
  orderBy } from './../../../../redux/helpers';
import { getLayoutsByType } from './../../../../redux/helpers/layouts';
import { imageChange } from '../../../../redux/actions/ui/imageChange';

class AddFlyleaf extends Component {
  constructor(props) {
    super(props);
    const { lang } = this.props;
    this.alertConfig = {
      title: lang.top_menu_fly_leaf_warn,
      type: 'warning',
      confirmButtonText: lang.yes,
      cancelButtonText: lang.no,
    };

    this.state = {
      addNewPage: false,
    };
  }

  componentDidUpdate() {
    const {
      allIds,
      layoutsById,
    } = this.props;

    if (this.state.addNewPage) {
      const [pageId] = allIds.slice(-1);

      this.props.dispatch(setIsActive(pageId));

      const activePage = Object.values(this.props.pagesById).find(element => element.id === pageId);
      const { isBackFlyLeaf: pageBackFylLeaf, isFrontFlyLeaf: pageFrontFylLeaf } = activePage;

      let layoutsArray = convertObjectToArray(layoutsById).filter(layout => !layout.isCover && !layout.isBackFlyleaf && !layout.isFrontFlyleaf);
      if (pageFrontFylLeaf) {
        layoutsArray = getLayoutsByType(layoutsById, 'isFrontFlyleaf');
      }

      if (pageBackFylLeaf) {
        layoutsArray = getLayoutsByType(layoutsById, 'isBackFlyleaf');
      }

      const ordered = orderBy(layoutsArray, 'order');
      const [layoutId] = ordered.slice(0);
      this.setState({
        addNewPage: false,
      }, () => {
        this.props.dispatch(setLayoutToActivePage(layoutId.id, pageId, false, false));
        this.props.dispatch(imageChange(false));
      });
    }
  }

  setPageState = () => this.setState({
    addNewPage: true,
  })

  addFlyleaf = (isFrontFlyLeaf, isBackFlyLeaf) => {
    const {
      backFlyLeaf,
      frontFlyLeaf,
      isChange,
      isCoverPage,
      pages,
      lang,
      maxSheets
    } = this.props;

    if (isImageInChange(isChange, isCoverPage, lang)) {
      return null;
    }

    // +1 is cover 
    if ((pages + 2) > (maxSheets + 1)) {
        showAlertModal(lang.title_notice, lang.flyleafError);
        return
    }

    swal({
      title: this.alertConfig.title,
      type: this.alertConfig.type,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.alertConfig.confirmButtonText,
      cancelButtonText: this.alertConfig.cancelButtonText,
    }).then((result) => {
      if (result.value) {
        const flyLeafProps = {
          isFrontFlyLeaf,
          isBackFlyLeaf,
          backFlyLeaf,
          frontFlyLeaf,
        };
        this.generateFlyleaf(flyLeafProps);
      }
    });
  }


  async generateFlyleaf(flyLeafProps) {
    const { isFrontFlyLeaf, isBackFlyLeaf } = flyLeafProps;
    if (!isFrontFlyLeaf) {
      await this.props.dispatch(createPageReorder(this.FirstFlyleaf));
      await this.setPageState();
    }
    if (!isBackFlyLeaf) {
      await this.props.dispatch(createPage(this.LastFlyleaf));
      await this.setPageState();
    }
  }

  render() {
    const {
      pages,
      isCover,
      pageBackgroundColor,
      pageBackgroundImage,
      lang,
      sizes,
      pageBackgroundImageFull,
      pagesById,
    } = this.props;

    this.FirstFlyleaf = {
      isFrontFlyLeaf: true,
      order: isCover.order + 1,
      backgroundColor: pageBackgroundImage !== '' ? null : pageBackgroundColor,
      backgroundImages: {
        thumbnail: pageBackgroundImage,
        full: pageBackgroundImageFull,
        sizes,
      },
    };
    this.LastFlyleaf = {
      isBackFlyLeaf: true,
      order: pages,
      backgroundColor: pageBackgroundImage !== '' ? null : pageBackgroundColor,
      backgroundImages: {
        thumbnail: pageBackgroundImage,
        full: pageBackgroundImageFull,
        sizes,
      },
    };

    const hasFrontFlyleaf = Object.values(pagesById).some(element => element.isFrontFlyLeaf);
    const hasBackFlyleaf = Object.values(pagesById).some(element => element.isBackFlyLeaf);
    return (
      <div className="flyleaf-wrapper">
        <div>
          <button className="btn green-btn add-flylief" onClick={() => this.addFlyleaf(hasFrontFlyleaf, hasBackFlyleaf)}>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
              <path d="M11,0V2H0V14H11v2h1V0ZM8,8H6v2H5V8H3V7H5V5H6V7H8Z" />
            </svg>
            {lang.top_menu_front_fly_leaf}
          </button>
        </div>
      </div>
    );
  }
}

AddFlyleaf.defaultProps = {
  pages: 0,
  backFlyLeaf: false,
  frontFlyLeaf: false,
  isCover: {},
  lang: {},
  pageBackgroundColor: '#fff',
  pageBackgroundImage: '',
  isCoverPage: false,
  dispatch: () => {},
  isChange: false,
  allIds: [],
  layoutsById: {},
  pageBackgroundImageFull: '',
  pagesById: {},
};

AddFlyleaf.propTypes = {
  pages: PropTypes.number,
  backFlyLeaf: PropTypes.bool,
  frontFlyLeaf: PropTypes.bool,
  isCover: PropTypes.object,
  lang: PropTypes.object,
  pageBackgroundColor: PropTypes.string,
  pageBackgroundImage: PropTypes.string,
  isCoverPage: PropTypes.bool,
  dispatch: PropTypes.func,
  isChange: PropTypes.bool,
  allIds: PropTypes.array,
  maxSheets: PropTypes.number,
  layoutsById: PropTypes.object,
  pageBackgroundImageFull: PropTypes.string,
  pagesById: PropTypes.object,
};

export default connect(state => ({
  layouts: state.entities.layouts.allIds,
  layoutsById: state.entities.layouts.byId,
  maxSheets: state.bookProperties.maxSheets,
  texts: state.entities.texts,
  pageBackgroundImage: state.editorUI.bookProperties.backgroundImage,
}))(AddFlyleaf);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/add-flyleaf/addFlyleaf.jsx